var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":""}},[_c('b',[_vm._v("На основе текущих данных создастся отдельное резюме. Продолжить?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }